var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "wdrClaim" }, [
    _setup.claimob.wait ? _c("div", [_vm._v("ожидайте...")]) : _vm._e(),
    _vm._v(" "),
    !_setup.claimob.wait && _setup.claimob.message
      ? _c("div", [_vm._v(_vm._s(_setup.claimob.message))])
      : _vm._e(),
    _vm._v(" "),
    !_setup.claimob.wait && !_setup.claimob.message
      ? _c(
          "div",
          [
            _setup.isActive(_setup.claimob.status)
              ? [
                  _c("div", { staticClass: "wdrClaimT" }, [
                    _vm._v("Вознаграждение"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wdrClaimOk" },
                    [
                      _c(_setup.RewardIcon),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("заявка на выплату "),
                        _c("b", [_vm._v(_vm._s(_setup.claimob.reward.sum))]),
                        _vm._v("р создана"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          attrs: { href: _setup.props.link, target: "_blank" },
                        },
                        [_vm._v("статус выплаты, документы")]
                      ),
                    ],
                    1
                  ),
                ]
              : _setup.isBefore(_setup.claimob.status)
              ? [
                  _c("div", { staticClass: "wdrClaimT" }, [
                    _vm._v("Вознаграждение"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wdrClaimOk" },
                    [
                      _c(_setup.RewardIcon),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("доступно "),
                        _c("b", [
                          _vm._v(_vm._s(_setup.claimob.reward.sum) + "р"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _setup.claimob.status.whynot
                        ? _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_setup.claimob.status.whynot),
                            },
                          })
                        : _c("div", [
                            _vm._v(_vm._s(_setup.claimob.status.name)),
                          ]),
                    ],
                    1
                  ),
                ]
              : _setup.isShould(_setup.claimob.status) ||
                _setup.isReady(_setup.claimob.status)
              ? [
                  _c("div", { staticClass: "wdrClaimT" }, [
                    _vm._v("Вознаграждение"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "wdrClaimOk" },
                    [
                      _c(_setup.RewardIcon),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("доступно "),
                        _c("b", [
                          _vm._v(_vm._s(_setup.claimob.reward.sum) + "р"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _setup.claimob.access.allow
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: _setup.props.link,
                                target: "_blank",
                              },
                            },
                            [_vm._v("получить")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_setup.claimob.access.allow
                    ? _c("div", {
                        staticClass: "wdrClaim__Not",
                        domProps: {
                          textContent: _vm._s(_setup.claimob.access.whynot),
                        },
                      })
                    : _vm._e(),
                ]
              : void 0,
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }